import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SidebarGpBuyer from "./SidebarGpBuyer";
import "../../../../styles/layout.css";

const GPLayout = ({ children, module = "gp" }) => {
  const handleSignOut = () => {
    console.log("Signing out...");
  };

  return (
    <div className="buyer-dashboard layout-css">
      <Header onSignOut={handleSignOut} module={module}/>
      <div className="display-flex">
        <div className="sidebar-css">
          {module === "gpbuyer" ? (
            <SidebarGpBuyer module={module} />
          ) : (
            <Sidebar module={module} />
          )}
        </div>
        <div className="content-css">{children}</div>
      </div>
    </div>
  );
};

export default GPLayout;